module.exports = __webpack_public_path__ + "static/media/slide0Inactive.d54e83ac.png";